const addToWishlistButtons = document.querySelectorAll(".js-add-to-wishlist");
const dialog = document.getElementById("js-wishlist-dialog");

const wishlistInput = document.getElementById("js-wishlist-product-id");

function addToWishList(id) {
    dialog.open = true;
    document.body.classList.add("overlay");
    wishlistInput.value = id;
}

if(dialog && addToWishlistButtons.length) {
    addToWishlistButtons.forEach((button) => {

        button.addEventListener("click", () => {
            addToWishList(button.getAttribute("data-id"));
        })

        dialog.querySelector(".js-close-dialog").addEventListener("click", () => {
            dialog.open = false;
            document.body.classList.remove("overlay");
        });
     });
}

function removeFromWishList(id) {
    // Find the form element
    const form = document.querySelector(".js-wishlist-edit-form");

    // Append the product id to the form
    const formData = new FormData(form);
    formData.append(`wishlist_product[${id}][remove]`, '1');

    // Send the form data to the server
    fetch(window.location.href, {
        method: 'POST',
        body: formData
    })
}

const removeFromWishlistButtons = document.querySelectorAll(".js-remove-from-wishlist");
if(removeFromWishlistButtons.length) {
    removeFromWishlistButtons.forEach((button) => {
        button.addEventListener("click", (e) => {
            e.preventDefault();

            removeFromWishList(button.getAttribute("data-id"));
            button.parentElement.parentElement.parentElement.parentElement.style.display = "none";
        });
    });
}
